
import { Component, Prop, Vue } from 'vue-property-decorator'
import { SubsidyStatus } from '../types'

@Component({ name: 'StatusBadge' })
export default class extends Vue {
  @Prop({ required: true }) status!: SubsidyStatus

  get label(): string {
    return String(this.$t(`cultureSubsidy.status.${this.status}`))
  }
}
